module.exports = __webpack_public_path__ + "img/logo.f4a55a54.png";